import React, { memo } from 'react';
import { Separator, Text } from '@cuemath/web-comps';
import COLORS from 'constants/colors';
import DetectionItem from '../detection-item';
import { FlexView } from '@cuemath/comps';

const DetectionList = ({ detections, activeDetectionType, onSelectDetection }) => {
  const detectionTypes = Object.keys(detections);
  const totalDetections = detectionTypes.length;

  return (
    <FlexView gap={16} gutter={16}>
      <FlexView>
        <Text variant="eyebrow2" color={COLORS.COLA_LIGHT}>
          Detections ({totalDetections})
        </Text>
        <Separator height={16} />
      </FlexView>
      {detectionTypes.map(type => (
        <DetectionItem
          key={type}
          detection={detections[type]}
          isActive={type === activeDetectionType}
          onSelect={onSelectDetection}
        />
      ))}
    </FlexView>
  );
};

export default memo(DetectionList);
